import { banco } from '../db/banco'
import { dentroDoPeriodo } from './calculo'
// ⚠ A lista vem DAQUI, e nao de uma copia local. O plano desta tarefa trazia a
// sua propria lista, sem 'entregue' -- que e exatamente o bug de producao
// consertado na Tarefa 2, e que so existiu porque cada arquivo tinha a sua
// copia. Com a lista errada, o cliente que comprou e JA RECEBEU a mercadoria
// apareceria como "nao comprou", e a tela mandaria cobrar quem ja comprou.
import { STATUS_VENDA } from './statusVenda'

// Os pedidos fechados do periodo, com os sub-pedidos DESTA marca que contam
// como venda. Uma passada so, reusada pelas duas respostas: as duas perguntas
// ("quem nao comprou" e "o que nao vendi") olham o mesmo recorte de vendas.
async function vendasDaMarcaNoPeriodo(
  representadaId: string, inicio: string, fim: string,
): Promise<{ clienteId: string; subPedidoId: string }[]> {
  const pedidos = await banco.pedidos
    .filter(
      (p) => p.apagado_em === null && p.status === 'fechado' && dentroDoPeriodo(p.data, inicio, fim),
    )
    .toArray()

  const vendas: { clienteId: string; subPedidoId: string }[] = []
  for (const pedido of pedidos) {
    const subs = await banco.sub_pedidos
      .where('pedido_id')
      .equals(pedido.id)
      .filter(
        (s) =>
          s.apagado_em === null &&
          s.representada_id === representadaId &&
          STATUS_VENDA.includes(s.status),
      )
      .toArray()
    for (const sub of subs) vendas.push({ clienteId: pedido.cliente_id, subPedidoId: sub.id })
  }
  return vendas
}

// "Quais clientes desta marca eu nao visitei/vendi no periodo?" -- a metade do
// pedido original dela que faltava: a tela dizia quanto faltava, nunca A QUEM
// ir atras.
export async function clientesQueNaoCompraram(
  representadaId: string, inicio: string, fim: string,
): Promise<string[]> {
  const vinculos = await banco.clientes_representadas
    .where('representada_id')
    .equals(representadaId)
    .filter((v) => v.apagado_em === null)
    .toArray()

  const compraram = new Set(
    (await vendasDaMarcaNoPeriodo(representadaId, inicio, fim)).map((v) => v.clienteId),
  )

  const nomes: string[] = []
  for (const vinculo of vinculos) {
    if (compraram.has(vinculo.cliente_id)) continue
    const cliente = await banco.clientes.get(vinculo.cliente_id)
    if (cliente && cliente.apagado_em === null) nomes.push(cliente.razao_social)
  }
  return nomes.sort()
}

// "Quais linhas da marca eu nao vendi no periodo?" So produto ATIVO conta: uma
// linha que saiu de catalogo nao pode virar cobranca de algo que nem se vende
// mais.
export async function linhasNaoVendidas(
  representadaId: string, inicio: string, fim: string,
): Promise<string[]> {
  const produtos = await banco.produtos
    .where('representada_id')
    .equals(representadaId)
    .filter((p) => p.apagado_em === null && p.ativo && p.linha !== null)
    .toArray()

  const existentes = new Set(produtos.map((p) => p.linha as string))
  if (existentes.size === 0) return []

  const linhaPorProduto = new Map(produtos.map((p) => [p.id, p.linha as string]))
  const vendidas = new Set<string>()

  for (const venda of await vendasDaMarcaNoPeriodo(representadaId, inicio, fim)) {
    const itens = await banco.itens_pedido
      .where('sub_pedido_id')
      .equals(venda.subPedidoId)
      .filter((i) => i.apagado_em === null)
      .toArray()
    for (const item of itens) {
      const linha = linhaPorProduto.get(item.produto_id)
      if (linha) vendidas.add(linha)
    }
  }

  return [...existentes].filter((l) => !vendidas.has(l)).sort()
}
